<template>
  <div class="gw_mesblock">
    <div
      class="gw_mesblock_title"
      v-html="
        title ||
        $t(`messages.postflop_equity_only`, {
          value: posflopContent,
        })
      "
    />
    <div
      v-if="hasShortcutBtn"
      class="gw_btn-v1"
      style="font-size: var(--btn-font-size); margin: var(--btn-margin)"
      @click="
        $store.dispatch(
          'router_set_dialogs',
          `preflop-shortcut-dialog${namespace ? `_namespace-${namespace}` : ''}` +
            `${canAISolve ? `_canAISolve-true` : ''}`,
        )
      "
    >
      <i class="mdi mdi-bookmark-outline text-large mr-2"></i>
      {{ $t('btn.select_postflop') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessagesGoPostflop',
  props: {
    namespace: { required: true, type: String, default: '' },
    title: String,
    posflopContent: String,
    hasShortcutBtn: { type: Boolean, default: true },
    canAISolve: { required: true, type: Boolean },
  },
}
</script>
